var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.$auth && _vm.$auth.loggedIn && _vm.notificationCount > 0 ? _c('div', {
    staticClass: "notification-badge",
    on: {
      "click": _vm.goToNotifications
    }
  }, [_c('span', {
    staticClass: "notification-badge__count"
  }, [_vm._v(_vm._s(_vm.notificationCount))])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }